import { styled } from '@mui/system'
import { fontSizes, colors } from '../../../Components/consts'

export const UpdateCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  background: colors.green,
  padding: theme.spacing(0, 2),
  '& p': {
    fontSize: fontSizes.medium,
    color: colors.white,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
    },
  },
}))
